export interface PagingParams{
    limit?: number,
    page: number
}
export const _paramsPagination: PagingParams = {
    limit: 10,
    page: 1
}